import { FC } from "react";

type LabelForInputRadio = {
  id: string;
  text: string;
};

const LabelForInputRadio: FC<LabelForInputRadio> = ({ id, text }) => {
  return (
    <label
      htmlFor={id}
      className="ml-3 block text-sm font-medium leading-6 text-gray-900"
    >
      {text}
    </label>
  );
};

export default LabelForInputRadio;
